import { Injectable } from "@angular/core";
import { UiStyle } from "../enums/ui-style";
import { IUiStyle } from "./ui-style";

@Injectable({
    providedIn: 'root'
})
export class UiStyleService implements IUiStyle {
    
    current(): UiStyle {
        return (UiStyle.Material) ;
    } ;

}